import React from 'react'
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom'
import Header from './layouts/Header'
import Footer from './layouts/Footer'
import PageContainer from './layouts/PageContainer'
import Portfolio from './features/Portfolio'
import Shop from './features/Shop'
import NotFound from './components/NotFound'
import PrivacyPage from 'components/CommingSoon/PrivacyP'
import WarrantyPage from 'components/CommingSoon/WarrantyRP'
import QuestionPage from 'components/CommingSoon/FrequentlyAQ'
import ShopCart from 'features/Shop/pages/Cart/ShopCart'
import ShopCheckout from 'features/Shop/pages/Checkout/ShopCheckout'
import { CartProvider } from 'context/shop/CartProvider'
import { PrivateCheckout } from 'utils/PrivateCheckout'
function App() {
  return (
    <CartProvider>
      <Router>
        <Header />
        <PageContainer>
          <Routes>
            <Route path="/" element={<Portfolio />} />
            <Route path="/shop/*" element={<Shop />} />
            <Route path="/cart" element={<ShopCart />} />
            <Route
              path="/checkout"
              element={
                <PrivateCheckout>
                  <ShopCheckout />
                </PrivateCheckout>
              }
            />
            <Route path="/policy" element={<PrivacyPage />} />
            <Route path="/questions" element={<QuestionPage />} />
            <Route path="/warranty&Return" element={<WarrantyPage />} />

            <Route path="*" element={<NotFound />} />
          </Routes>
        </PageContainer>
        <Footer />
      </Router>
    </CartProvider>
  )
}

export default App
